import React, { Component } from 'react';
import './screensaver.css';
import Shake from 'shake.js';


class Screensaver extends Component {
    constructor(props) {
        super(props);
        this.screenAlert;
        this.shaker = new Shake({
            threshold: 11, // optional shake strength threshold
            timeout: 1000 // optional, determines the frequency of event generation
        });
        this.currentQuote = [];
        this.mapKeys = {};
        this.currentImage = null;
        this.state = {
            quotes: [],
            saverStage: false,
            quoteActive: false          
        
      };
    }


    componentDidMount() {
        this.getQuotes();
    }

  

    closeMessage(e){
        console.log('close')
            
    }

    getQuotes = () => {

        fetch('/api/quotes')
        .then(res => res.json())
        .then(quotes => this.setState({ quotes }))
        .then(()=>{
            this.shaker.start();
            this.screenAlert =  window.setTimeout(this.screenSave, 90000);
            window.addEventListener("mousemove", this.resetTimer, false);
            window.addEventListener("mousedown", this.resetTimer, false);
            window.addEventListener("DOMMouseScroll", this.resetTimer, false);
            window.addEventListener("mousewheel", this.resetTimer, false);
            window.addEventListener("touchmove", this.resetTimer, false);
            window.addEventListener("MSPointerMove", this.resetTimer, false);
            window.addEventListener('keydown', this.manualScreen, false); 
            window.addEventListener('shake', this.manualShake, true); 
        })

    }

    manualShake=()=>{
        this.screenSave();
        this.flashScreen();
    }
    manualScreen=(e)=> {
        if (e.defaultPrevented) {
            return;
        }
     
        this.mapKeys[e.key] = e.type === 'keydown';
        if((this.mapKeys['a'] && this.mapKeys['b'] && this.mapKeys['s']) || (this.mapKeys['A'] && this.mapKeys['B'] && this.mapKeys['S']) ){ // BSA
            this.screenSave();
            this.flashScreen();
            this.mapKeys = {}}
        else{this.resetTimer()}
        // if(){
      

        // }


    };


    flashScreen=()=>{
        var screenFlash = document.getElementsByClassName('randomFlashStage')
        if(screenFlash.length){
            screenFlash[0].classList.add('active')
        }
        var closeFlash = window.setTimeout(this.stopFlash, 750);
    }

    stopFlash=()=>{
        var screenFlash = document.getElementsByClassName('randomFlashStage')
        if(screenFlash.length){
            screenFlash[0].classList.remove('active')
        }
    }

    resetTimer=()=>{
    
    if(!this.state.saverStage){
        clearTimeout(this.screenAlert)
        this.screenAlert =  window.setTimeout(this.screenSave, 90000);
        }
    else{
        var stageToHide = document.getElementsByClassName('saverStage')
        if(stageToHide.length){
            stageToHide[0].classList.add('hiddenSaver')
        }
        var quoteToHide = document.getElementsByClassName('randomQuoteHolder')
        if(quoteToHide.length){
            quoteToHide[0].classList.add('hiddenQuote')
        }
        
        this.closeScreen();
    }
    }

    closeScreen=()=>{
        clearTimeout(this.screenAlert)
        this.setState({saverStage: false, quoteActive:false})
        this.screenAlert =  window.setTimeout(this.screenSave, 90000);
        
    }

    screenSave= () => {
        clearTimeout(this.screenAlert);
        if (!this.state.saverStage){
            this.setState({saverStage: true})
            var currentStage = document.getElementsByClassName("hiddenSaver")
            if(currentStage.length){
                currentStage[0].classList.remove('hiddenSaver')
            }
            
        };
        if(this.state.quoteActive){
            this.removeCurrentQuote()
        }else{
            this.displayNewQuote()
        }


    }

  
    removeCurrentQuote=()=>{
        clearTimeout(this.screenAlert);
        console.log('removing quote')
        var quoteHolder = document.getElementsByClassName('randomQuoteHolder')
        quoteHolder[0].classList.add('hiddenQuote')
        this.screenAlert =  window.setTimeout(this.displayNewQuote, 2000);

    }

    displayNewQuote=()=>{
        clearTimeout(this.screenAlert);
        this.currentQuote = this.state.quotes[Math.floor(Math.random()*this.state.quotes.length)];
        if(this.currentQuote.images.length){
            this.currentImage = this.currentQuote.images[0].imgURL;
            console.log(this.currentImage)
        }else{this.currentImage=null;console.log(this.currentImage)}

        this.setState({quoteActive: true})
        var hiddenQuote = document.getElementsByClassName("hiddenQuote")
            if(hiddenQuote.length){
                hiddenQuote[0].classList.remove('hiddenQuote')
            }
        console.log("new quote: "+this.currentQuote.quoteName)
        this.screenAlert =  window.setTimeout(this.screenSave, 20000);

    }




    

      

     

 

 
 
    render() {
        return (
           <React.Fragment>
            <div className="randomQuoteHolder fullWidth hiddenQuote wT clearBoth fullHeight relative">
                    <div className="randomQuoteImg randomQuoteBlock floatLeft fullHeight relative">
                    {this.currentImage ? (
                        <img className="centeredContent" src={this.currentImage} alt="quotePhoto"></img>
                    ):(
                        <img className="quoteLogo centeredContent" src="../images/BSALogo.svg" alt="quotePhoto"></img>
                    )}
                        
                    </div>
                    <div className="randomQuoteText randomQuoteBlock floatLeft relative fullHeight">
                        <div className="fullWidth contentQuote centeredContent">
                            <div className="randomQuoteCopy marginBotSmall" dangerouslySetInnerHTML={{ __html : this.currentQuote.quoteCopy }}></div>
                            <div className="resourceTitle boldT upperT titleFont">{this.currentQuote.quoteName}</div>
                        </div>
                        <p className="insightCount upperT">No.{this.currentQuote.id}</p>
                    
                    </div>
            
                   

            <div className="fullWidth fullHeight randomFlashStage"></div>
            
            </div>
         </React.Fragment> 
        )
    }
  }
  
  export default Screensaver;


// WEBPACK FOOTER //
// ./src/components/sitemap/screensaver.js